module.exports = __webpack_public_path__ + "img/product-detail.6eb9ddc6.png";